import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useProfileNavigation } from 'common/hooks/useProfileNavigation'
import { Typography, TypographyVariants } from 'common/typography'
import { formatUserName } from 'common/utils/formatUserName'
import { getMyProfile } from 'features/MyProfile/selectors'
import { ProfileIcon } from 'features/NavBar/components/DropDownButton/ProfileIcon'
import styles from './styles.module.sass'

interface IProfileSection {
  onAfterClick?: () => void
}

export const ProfileSection: FC<IProfileSection> = ({ onAfterClick }) => {
  const location = useLocation()
  const profile = useSelector(getMyProfile)
  const { navigateToProfile } = useProfileNavigation()

  const navigateToUserProfile = () => {
    if (profile) {
      navigateToProfile(location.pathname, profile.uid, profile.username)
    }
    onAfterClick?.()
  }

  return (
    <div className={styles.dropdownProfileSection}>
      <div className={styles.profileHeader} onClick={navigateToUserProfile}>
        <div className={styles.imgContainer}>
          <ProfileIcon />
        </div>
        <div className={styles.profileDetails}>
          <Typography
            variant={TypographyVariants.Desktop_UI_M_Medium}
            tag="p"
            className={styles.profileName}
          >
            {profile && formatUserName(profile)}
          </Typography>
          <Typography
            variant={TypographyVariants.Desktop_UI_S_Medium}
            tag="p"
            className={styles.jobName}
          >
            {profile?.job?.title || ''}
          </Typography>
        </div>
      </div>
    </div>
  )
}
